import gql from "graphql-tag";

export const GetClientMessages = gql`
  query clientMessages(
    $brokerId: String!
    $clientId: String!
    $token: String!
  ) {
    ClientMessages(brokerId: $brokerId, clientId: $clientId, token: $token) {
      Client {
        id
        client_fullname
        client_avatar
      }
      Messages {
        id
        sender_id
        message
        date_sent
      }
    }
  }
`;

export const GetClientMessageHistory = gql`
  query clientMessageHistory(
    $brokerId: String!
    $token: String!
    $limit: Int!
    $page: Int!
    $orderBy: String
    $direction: String
    $search: String
  ) {
    ClientMessageHistory(
      brokerId: $brokerId
      token: $token
      limit: $limit
      page: $page
      orderBy: $orderBy
      direction: $direction
      search: $search
    ) {
      Count
      Results {
        id
        clientFullName
        latest_message_date
        unread_messages
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/messaging/queries.js